<div class="content-wrapper">
    <div class="user-info-section">
        <h1 class="greeting">Hello {{ firstName }}</h1>

        <div class="details-grid">
            <div class="detail-row">
                <span class="detail-label">First Name:</span>
                <span class="detail-value">{{ firstName }}</span>
            </div>
            <div class="detail-row">
                <span class="detail-label">Last Name:</span>
                <span class="detail-value">{{ lastName }}</span>
            </div>
            <div class="detail-row">
                <span class="detail-label">Email:</span>
                <span class="detail-value">{{ email }}</span>
            </div>
        </div>
    </div>

    
    <div class="divider"></div>

    <div class="actions-section">
        <a class="action-btn btn-onboard" [class.disabled]="!canOnboard"
            (click)="onActionLinkClick($event, canOnboard, onboardUrl)">
            Onboard - Your Expats <span class="icon">↗</span>
        </a>

        <a class="action-btn btn-select" [class.disabled]="!canSelect"
            (click)="onActionLinkClick($event, canSelect, selectUrl)">
            Select - Your Expats <span class="icon">↗</span>
        </a>

        <a class="action-btn btn-test" [class.disabled]="!canTest"
            (click)="onActionLinkClick($event, canTest, testUrl)">
            Test - Your Expats <span class="icon">↗</span>
        </a>

        <a class="action-btn btn-find" [class.disabled]="!canFind"
            (click)="onActionLinkClick($event, canFind, findUrl)">
            Find - Your Expats <span class="icon">↗</span>
        </a>

        <button class="action-btn btn-logout" (click)="onLogoutClick()">
            Logout
        </button>
    </div>
</div>